// import axios from 'axios';
// import { useFormik } from 'formik';
import axios from 'axios';
import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { BASE_URL, LOGIN } from '../../constant-value';
import { setUserIdFromBody } from '../../redux/user/userSlice';
import api from '../../services/axiosConfig';
// import { toast } from 'react-toastify';
// import { BASE_URL, LOGIN } from '../../constant-value';
// import { validationLoginSchema } from '../../constant-value/schema';

const Login = () => {
    // const navigate = useNavigate();
    // const [user, setUser] = useState({
    //     userName: '',
    //     password: ''
    //   });


    // const {
    //     values,
    //     errors,
    //     touched,
    //     isSubmitting,
    //     handleBlur,
    //     handleChange,
    //     handleSubmit,
    // } = useFormik({
    //     enableReinitialize: true,
    //     initialValues: user,
    //     validationSchema: validationLoginSchema,    
    //     onSubmit: (values) => {
    //         axios
    //           .post(`${BASE_URL}/${LOGIN}`, user).then((res) => {
    //             if (res.data.isSuccess) {
    //                 message(res.data.message,'success');
    //                 // handleSendData()
    //                 // nextStep();
    //                 navigate("/");
    //             } else {
    //                 message(res.data.message,'warn');
    //             }
    //         }).catch(error => { 
    //             if (error.response.status === 401) {
    //                 message('نام کاربری و یا رمز عبور اشتباه است','warn');
    //             }
    //             else{
    //                 message("جند دقیقه دیگر تلاش نمایید، خطایی رخ داده است", "warn");
    //             }
    //         });
    //     },
    // });

    // const changeHandle = (evt) => {
    //     setUser({
    //         ...user,
    //         [evt.target.id]: evt.target.value,
    //     })
    // }

    // const message = (message,type) => {
    //     if (type==='warn') {
    //         toast.warning(message, {
    //         autoClose: 3000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //         });
    //     } else {
    //         toast.success(message, {
    //         autoClose: 3000,
    //         hideProgressBar: false,
    //         closeOnClick: true,
    //         pauseOnHover: true,
    //         draggable: true,
    //         progress: undefined,
    //         });
    //     }
    // }

    const [userName, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userId = useSelector(state => state.user.userId);


    // useEffect(() => {
    //   console.log('first')
    //   console.log(userId)
    //   if (userId) {
    //     navigate('/');
    //   }
    // }, [userId]);
    
    // const handleLogin = async (e) => {
    //     e.preventDefault();
    //     try {
    //         await login(username, password);
    //         navigate('/'); // انتقال به صفحه اصلی پس از لاگین
    //     } catch (error) {
    //         alert('Login failed!');
    //     }
    // };

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);
   
        try {  
          const res = await api.post(LOGIN, { 
              userName, 
              password
          });
          if (res.data.isSuccess) {
                navigate('/');
            } else {
                navigate('/login');
                setMessage(res.data.message);
            }
        } catch (error) {
          console.log('error')
          // خطاها به صورت خودکار توسط interceptor مدیریت می‌شوند
          setMessage(
            error.response?.data?.message || 
            'خطا در ارتباط با سرور'
          );
        } finally {
          setIsLoading(false);
        }
      };


  return (
    <div className="container-fluid vh-100 bg-light">
      <div className="row h-100 justify-content-center align-items-center">
        <div className="col-md-5 col-lg-4">
          <div className="card shadow-sm border-0 rounded-4">
            <div className="card-body p-4 p-md-5">
              <h2 className="text-center mb-4 fw-bold text-primary">ورود به حساب کاربری</h2>
              
              <form onSubmit={handleLogin} className="rtl-form">
                <div className="mb-3">
                  <label htmlFor="phone" className="form-label fw-medium">شماره همراه</label>
                  <input 
                    type="tel" 
                    className="form-control py-2 rounded-3" 
                    id="phone" 
                    value={userName} 
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="09xxxxxxxxx"
                    required
                  />
                </div>
                
                <div className="mb-4">
                  <label htmlFor="password" className="form-label fw-medium">رمز عبور</label>
                  <input 
                    type="password" 
                    className="form-control py-2 rounded-3" 
                    id="password" 
                    value={password} 
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="رمز عبور خود را وارد کنید"
                    required
                  />
                </div>
                
                {message && (
                  <div className={`alert ${message.includes('موفق') ? 'alert-success' : 'alert-danger'} mb-4`}>
                    {message}
                  </div>
                )}
                
                <button 
                  className="btn btn-primary w-100 py-2 rounded-3 fw-bold" 
                  type="submit" 
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      در حال ورود...
                    </>
                  ) : 'ورود'}
                </button>
              </form>
              
              <div className="d-flex justify-content-between mt-3">
                <Link to="/forgot" className="text-decoration-none text-muted">فراموشی رمز عبور</Link>
                <Link to="/register" className="text-decoration-none text-primary fw-medium">ثبت نام</Link>
              </div>
              
              {/* <div className="d-flex align-items-center my-4">
                <div className="border-bottom flex-grow-1"></div>
                <span className="px-3 text-muted">یا</span>
                <div className="border-bottom flex-grow-1"></div>
              </div> */}
              
              {/* <div className="d-grid gap-2">
                <button type="button" className="btn btn-outline-secondary rounded-3 py-2">
                  <i className="bi bi-google me-2"></i> ورود با گوگل
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      
      {/* اضافه کردن استایل برای فرم RTL */}
      <style>{`
        .rtl-form {
          direction: rtl;
          text-align: right;
        }
        .rounded-3 {
          border-radius: 0.5rem !important;
        }
      `}</style>
    </div>
  )
}

export default Login